module.exports = __webpack_public_path__ + "img/mrp.6bbd2cc6.png";